import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/obituary-fe/app/error.js");
